export default __webpack_public_path__ + "static/media/add.29d04709.svg";